import { render, staticRenderFns } from "./detailsCustomerSalesTable.vue?vue&type=template&id=a988a830&scoped=true"
import script from "./detailsCustomerSalesTable.vue?vue&type=script&lang=js"
export * from "./detailsCustomerSalesTable.vue?vue&type=script&lang=js"
import style0 from "./detailsCustomerSalesTable.vue?vue&type=style&index=0&id=a988a830&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a988a830",
  null
  
)

export default component.exports